angular
    .module('rmItemPlanner')
    .controller('ItemPlannerOverviewCtrl', require('./item_planner_overview_ctrl'))
    .controller('ItemPlannerCampaignFormCtrl', require('./item_planner_campaign_form_ctrl'))
    .controller('ItemPlannerItemFormCtrl', require('./item_planner_item_form_ctrl').default)
    .controller('itemPlannerInfoDialogCtrl', require('./item_planner_info_dialog_ctrl').default)
;
